(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enco-amigos-resposteros-info"]) return;
  try {
    

$(document).ready(function() {

	function count(sn_number){

	  var total = $(sn_number).text();
		  total = total.replace(',', '')
		  total = $.isNumeric(total) ? parseInt(total) : 0;	  

      var Cont={val: 0} , NewVal = total;

      TweenLite.to(Cont,5,{val:NewVal,roundProps:"val",onUpdate:function(){
        
        $(sn_number).html(Cont.val.toLocaleString())
      }});
    }

    count('#ig-followers');
    count('#fb-followers');
	count('#tk-followers');
    count('#yt-subscribers');

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-cupcakes"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-esencias"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-festividades"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-fondant"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-galletas"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-panificacion"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-pasteles"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-plantillas"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-collection-template-creaciones-postres"]) return;
  try {
    

$(document).ready(function() {

	
	var split = location.search.replace('?', '').split('=')
    if(split.length == 2){
       $('section').removeClass();
	   $('section').addClass('collection '+ split[1]);
       $('#category-page').attr('href','https://encoalimentos.com/pages/'+ split[1]);
	   $('#category-page').text(split[1]);
    }

 	$('.test-popup-link').magnificPopup({
      type: 'image'
      // other options
    });

    $('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-customer-list"] && !Shopify.designMode) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

  $jq('.customer-list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
		responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
        		slidesToScroll: 1,
              }
            }
       ]
  });

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-descargables-gallery"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $("#shopify-section-enco-descargables-gallery .grid__item").length == 0 ){
        $("#shopify-section-enco-descargables-gallery").hide();
      }

      var url = new URL(location.href);
      var params = new URLSearchParams(url.search);
      var show_top_flag = params.get('descargable');
      if ( show_top_flag != null ) {
          $("#pills-tab .nav-link").removeClass('active');
          $("#pills-tabContent .tab-pane").removeClass('active').removeClass('show');

          $( "#pills-tab .nav-link" ).each(function( index ) {
            id = $( this ).attr('id');
            if(show_top_flag==id){
              $("#collapse-"+id).addClass('show');
              $("#" + id).addClass('active');
              $("#pills-" + id).addClass('active').addClass('show');
              return false;
            }
          });

      }
  });

  $('.carousel-decargables').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ],
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
  });

  $('.descargables-gallery').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        }
    });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-distribuidores-gallery"]) return;
  try {
    

$(document).ready(function() {

	$('#state').on('change', function() { 
      $('.grid__item').hide();
      if(this.value === 'all'){
        $('.grid__item').show();
      }else{
        $('.grid__item.' + this.value).show()
      }
    }); 

  

    var url = new URL(location.href);
    var params = new URLSearchParams(url.search);
    var param = params.get('country');
    if ( param != null ) {  
      $("#country").val(param);
      $('#country').change(); 
    }
  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-home-carrusel-gallery"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      $('.carrusel-gallery').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-home-recetas-mas-gallery"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      $('.carrusel-recetas-mas').slick({
          slidesToShow: 8,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
          		  slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-home-slideshow"] && !Shopify.designMode) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 


  function applyEffect(indexSlide){

	var originalText = []
	var selector = $('.enco-content-text').eq(indexSlide).find('.ml9 .letters');
	selector.each(function( indexText ) {
		originalText.push( $(this).text() )
        $(this).html($(this).text().replace(/\S/g, "<span class='letter'>$&</span>"));
    });
    
    anime.timeline({loop: false})
    .add({
      targets: '.ml9 .letter',
      scale: [0, 1],
      duration: 1500,
      elasticity: 600,
      delay: (el, i) => 45 * (i+1),
	  complete: function(){
	  	selector.each(function( indexText ) {
            $(this).html( originalText[indexText] );
        });
      }
	 
    }).finished;

  }

  /*
  var $carousel = $('.slideshow-carousel');
  $carousel.on( 'select.flickity', function( event, index ) {

	//applyEffect(index); 

    $('img.product_card__image').removeClass('animate__animated animate__bounceIn');
    $('img.product_card__image').eq(index).addClass('animate__animated animate__bounceIn'); 

    $('.enco-content-text .description').removeClass('animate__animated animate__fadeInDown');
    $('.enco-content-text .description').eq(index).addClass('animate__animated animate__fadeInDown'); 

    $('.enco-content-text .button').removeClass('animate__animated animate__fadeInDown');
    $('.enco-content-text .button').eq(index).addClass('animate__animated animate__fadeInDown'); 

  });
  */
  
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-home-tips-blog"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();

  
  $(document).ready(function() {

    $('.carousel-blog').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true
    });

    $('.carrusel-sobrinos').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		  slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
    });

  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-benefist-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $(".carousel-benefits .grid__item").length == 0 ){
          $(".carousel-benefits").parents(".gallery").hide();
      }
    
      $('.carousel-benefits').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
            	  slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-card-gallery"]) return;
  try {
    
var $ = jQuery.noConflict();

$(document).ready(function() { 

    if( $(".carousel-productos-variedad .grid__item").length == 0 ){
        $(".carousel-productos-variedad").parents(".gallery").hide();
    } 

    $('.carousel-productos-variedad').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
		responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 1,
        		slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
  });


  if( $(".carousel-amazon .grid__item").length == 0 ){
      $(".carousel-amazon").parents(".gallery").hide();
  }
    
      $('.carousel-amazon').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
      });
  
  
});
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-discover-carousel-gallery"]) return;
  try {
    
var $ = jQuery.noConflict();

$(document).ready(function() { 

    if( $(".carousel-discover .grid__item").length == 0 ){
        $(".carousel-discover").parents(".gallery").hide();  
    }

    $('.carousel-discover').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
		responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
        		slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
  });
  
  
});
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-download-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $(".carousel-download .grid__item").length == 0 ){
          $(".carousel-download").parents(".gallery").hide(); 
      } 

      $('.carousel-download').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ] 
      });
     
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-icon-label-gallery"]) return;
  try {
    
var $ = jQuery.noConflict();

$(document).ready(function() { 

    if( $(".carousel-icon-label .grid__item").length == 0 ){
        $(".carousel-icon-label").parents(".gallery").hide(); 
    }
/*
    $('.carousel-icon-label').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
		responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 1,
        		slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
  });
*/  
  
  
});
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-presentation-carousel-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $(".carousel-presentation-gallery .grid__item").length == 0 ){
          $(".carousel-presentation-gallery").parents(".gallery").hide();
      }
    
      $('.carousel-presentation-gallery').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
      });

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-presentation-gallery"]) return;
  try {
    
var $ = jQuery.noConflict();

$(document).ready(function() { 

    if( $(".carousel-presentation .grid__item").length == 0 ){
        $(".carousel-presentation").parents(".gallery").hide();  
    }

    $('.carousel-presentation').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
		responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 1,
        		slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
  });
  
  
});
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-store-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();
    
  $(document).ready(function() { 

    if( $(".carousel-supplier .grid__item").length == 0 ){
        $(".carousel-supplier").parents(".gallery").hide();
    }

    $('.carousel-supplier').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
    });
    
  });
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-product-video-gallery"]) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

  $('.main-carousel').flickity({
    // options
    cellAlign: 'center', 
    contain: true
  });

	$('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });

    if( $(".carousel-videos .carousel-cell").length == 0 ){ 
      $(".carousel-videos").hide();
    } 
  
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-carrusel-gallery-pre"]) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $("#shopify-section-enco-productos-carrusel-gallery-pre .grid__item").length == 0 ){
          $("#shopify-section-enco-productos-carrusel-gallery-pre").hide();
      }

      $('.carrusel-gallery-pre').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        }
    });

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-carrusel-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {

      if( $("#shopify-section-enco-productos-carrusel-gallery .grid__item").length == 0 ){
          $("#shopify-section-enco-productos-carrusel-gallery").hide();
      }

      $('.carrusel-gallery').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-carrusel-videos-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();

  
  $(document).ready(function() {

      if( $("#shopify-section-enco-productos-carrusel-video-gallery .grid__item").length == 0 ){
          $("#shopify-section-enco-productos-carrusel-video-gallery").hide();
      }

      $('.carrusel-video-gallery').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
  		  responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ],
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-extra-content"]) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

    if( $("#shopify-section-enco-productos-extra-content .feature-row").length == 0 ){
      $("#shopify-section-enco-productos-extra-content").hide(); 
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-full-collection-template"]) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

  $('.main-carousel').flickity({
    // options
    cellAlign: 'center', 
    contain: true
  });

	$('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });


});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-instrucciones-gallery"]) return;
  try {
    

var $ = jQuery.noConflict();
$(document).ready(function() { 

    if( $("#shopify-section-enco-productos-instrucciones-gallery .grid__item").length == 0 ){
        $("#shopify-section-enco-productos-instrucciones-gallery").hide(); 
    }   

    $('.carousel-productos-instrucciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-chocoaditivo"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-color-blanco-plus"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-colores-en-gel"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-colores-liquidos"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-colores-naturales"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-concentrados-helados"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-desmoldante"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-dulce-de-frutas"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-esencias"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-fondant"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-jarabes-cafe-caveeni"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-jarabes-cafe"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-merengue"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-royal-icing"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-tintas-comestibles"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-presentaciones-tocino-en-trozos"]) return;
  try {
    
  var $ = jQuery.noConflict();
  $(document).ready(function() {

    $('.carousel-productos-presentaciones').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
  		responsive: [
              {
                breakpoint: 768,
                settings: {
                  autoplay: false,
                  slidesToShow: 1,
          		slidesToScroll: 1,
                  arrows: true,
                }
              }
         ]
    });


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-videos-slideshow-2"]) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

  $('.main-carousel').flickity({
    // options
    cellAlign: 'center', 
    contain: true
  });

	$('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });

    if( $(".carousel-cell").length == 0 ){
      $("#shopify-section-enco-productos-videos-slideshow-2").hide();
    }
   
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-productos-videos-slideshow"]) return;
  try {
    


var $jq = jQuery.noConflict();

$jq(document).ready(function() { 

  $('.main-carousel').flickity({
    // options
    cellAlign: 'center', 
    contain: true
  });

	$('.video').magnificPopup({
    	type: 'iframe',
        iframe: {
          markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                  '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
            vimeo: {
              index: 'vimeo.com/',
              id: '/',
              src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
              index: '//maps.google.',
              src: '%id%&output=embed'
            }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
		mainClass: 'mfp-with-zoom mfp-img-mobile',
        zoom: {
			enabled: true,
			duration: 300, // don't foget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}
    });

    if( $(".carousel-cell").length == 0 ){
      $("#shopify-section-enco-productos-videos-slideshow").hide();
    }
  
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-recetas-festividades-featured-grid"]) return;
  try {
    

$(document).ready(function() {
	
	$('#category').on('change', function() {
      console.log( this.value )
      $('.grid__item').hide();
      $('.' + this.value).show()
    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco-recetas-mas-amigos-featured-grid"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();

  $(document).ready(function() {


      var url = new URL(location.href);
      var params = new URLSearchParams(url.search);
      var show_top_flag = params.get('sobrinos');
      if ( show_top_flag != null ) {
          $("#pills-tab .nav-link").removeClass('active');
          $("#pills-tabContent .tab-pane").removeClass('active').removeClass('show');

          $( "#pills-tab .nav-link" ).each(function( index ) {
            id = $( this ).attr('id');
            if(show_top_flag==id){
              $("#collapse-"+id).addClass('show');
              $("#" + id).addClass('active');
              $("#pills-" + id).addClass('active').addClass('show');
              return false;
            }
          });

      }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco2025-conocenos-discover-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();
    
  $(document).ready(function() { 

    if( $(".carousel-discover .grid__item").length == 0 ){
        $(".carousel-discover").parents(".gallery").hide();
    }

    $('.carousel-discover').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
    });
    
    
  });
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco2025-descargables-tab-gallery"]) return;
  try {
    
  var $ = jQuery.noConflict();
    
  $(document).ready(function() { 

    if( $(".carousel-download .grid__item").length == 0 ){
        $(".carousel-download").parents(".gallery").hide();
    }

    $('.carousel-download').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
    });


    var url = new URL(location.href);
    var params = new URLSearchParams(url.search);
    var param = params.get('producto');
    if ( param != null ) {  
      $("a.nav-link").removeClass('active')
      $("div.tab-pane").removeClass('active').removeClass('show')
      $("a[aria-controls="+param+"]").addClass('active') 
      $("#"+param+".tab-pane").addClass('active').addClass('show') 
    }
    
  });
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco2025-home-productos-carrusel"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();
    
  $(document).ready(function() { 

    if( $(".carousel-productos .grid__item").length == 0 ){
        $(".carousel-productos").parents(".gallery").hide();
    }

    $('.carousel-productos').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false, 
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
    }); 
        
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enco2025-home-recetas-carrusel"] && !Shopify.designMode) return;
  try {
    
  var $ = jQuery.noConflict();
    
  $(document).ready(function() { 

    if( $(".carousel-recipes .grid__item").length == 0 ){
        $(".carousel-recipes").parents(".gallery").hide();
    }

    $('.carousel-recipes').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              }
            }
       ]
    });
        
  });



  } catch(e) { console.error(e); }
})();
})();
